module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("Virginia Dale has had two other books published: "), _c('em', [_vm._v("Never Marry in Morocco")]), _vm._v(" (Fifthian Press, 1996) and "), _c('em', [_vm._v("The Bushy Daughters Go to War and Find Rumi")]), _vm._v(" (iUniverse, 2007). Both received good reviews in the "), _c('em', [_vm._v("Santa Barbara Independent")]), _vm._v(", and she was scheduled for readings by them at the local book stores. There were several bookstores in 1996, and there is still an excellent independent one named Chaucer’s.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("She lived abroad for seven years in Madrid, Spain and Rabat, Morocco, where she became well acquainted with the Spanish, French, and Moroccan cultures. She currently resides in Santa Barbara, California.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0